<template>
  <div style="width: 900px;height: 450px;overflow-x: hidden;overflow-y: auto;z-index: 99;">
<!--  <div class="flex_column_all_label">-->

    <div>
      <span>Mode:</span>
      <el-select v-model="echart_select"
                 clearable
                 filterable
                 size="mini"
                 placeholder="please select">
        <el-option
            v-for="item in echart_list"
            :key="item"
            :label="item"
            :value="item">
        </el-option>
      </el-select>
      <el-button size="mini" type="info" round style="margin-left: 10px" @click="initEcharts">submit</el-button>
    </div>
    <div class="flex_row_all_label">

      <div id="groundtruth_allLable" style="width: 400px;height: 400px">
        <h3 style="margin-top: 0;padding-top: 0">
          <span>{{this.picText}}</span>
        </h3>
        <img :src="groundtruth_source" width="300px" id="allLabel_pic"
                   @error="hidePic"/>
        <!--           onerror="document.getElementById('groundtruth_allLable').style.display = 'none'"/></div>-->
        <div>
          <span @click="resetPic('allLabel_pic')">
            <i class="el-icon-refresh"></i>
          </span>
          <span @click="rotatePic('allLabel_pic')">
            <i class="el-icon-refresh-right"></i>
          </span>
          <span @click="horizonPic('allLabel_pic')">
            <i class="el-icon-right"></i>
          </span>
          <span @click="verticalPic('allLabel_pic')">
            <i class="el-icon-top"></i>
          </span>
        </div>
      </div>

      <div id="echart_allLable" style="width: 400px;height: 400px"/>

<!--      <div id="classification_allLable" style="width: 400px;height: 400px" v-show="classification_info.source.length !== 0"/>-->

<!--      <div id="anno_allLable" style="width: 400px;height: 400px" v-show="annot_type_info.source.length !== 0"/>-->
<!--      <div id="fine_anno_allLable" style="width: 400px;height: 400px" v-show="fine_annot_type_info.source.length !== 0"/>-->

<!--      <div id="celltype_allLable" style="width: 400px;height: 400px" v-show="celltype_info.source.length !== 0"/>-->
<!--      <div id="celltype_major_allLable" style="width: 400px;height: 400px" v-show="celltype_major_info.source.length !== 0"/>-->

<!--      <div id="celltype_minor_allLable" style="width: 400px;height: 400px" v-show="celltype_minor_info.source.length !== 0"/>-->
<!--      <div id="celltype_subset_allLable" style="width: 400px;height: 400px" v-show="celltype_subset_info.source.length !== 0"/>-->
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts/core";

export default {
  name: "AllLabelChart",
  data(){
    return{
      datasetID: '',
      datasetName: [20210101, 20210701, 20210702, 20210703],
      picText: 'H&E image',
      echart_select: '',
      echart_list: [],
      rotateX: 0,
      rotateY: 0,
      rotateZ: 0,
      groundtruth_source: '',
      COLOR_ALL: [
        '#37A2DA',
        '#e06343',
        '#37a354',
        '#b55dba',
        '#b5bd48',
        '#8378EA',
        '#96BFFF',
        '#E72178',
        '#354E6C','#EAAC31',
        '#EAD2AE',
        '#127678','#30B5A4','#B4D9D2',
        '#354581','#FFE074',
        '#E03C79','#88C1B8',
        '#FC6746','#F5B307','#008186'
      ],
      classification_info: {
        types: [],
        spotSize: 5,
        tip: [],
        source: []
      },
      annot_type_info: {
        types: [],
        spotSize: 5,
        tip: [],
        source: []
      },
      fine_annot_type_info: {
        types: [],
        spotSize: 5,
        tip: [],
        source: []
      },
      celltype_info: {
        types: [],
        spotSize: 5,
        tip: [],
        source: []
      },
      celltype_major_info: {
        types: [],
        spotSize: 5,
        tip: [],
        source: []
      },
      celltype_minor_info: {
        types: [],
        spotSize: 5,
        tip: [],
        source: []
      },
      celltype_subset_info: {
        types: [],
        spotSize: 5,
        tip: [],
        source: []
      }
    }
  },
  props:{
    datasetInfo: Array,
    asynClassification: {
      types: Array,
      spotSize: Number,
      tip: Array,
      source: Array
    },
    asynAnnot: {
      types: Array,
      spotSize: Number,
      tip: Array,
      source: Array
    },
    asynFineAnno: {
      types: Array,
      spotSize: Number,
      tip: Array,
      source: Array
    },
    asynCelltype: {
      types: Array,
      spotSize: Number,
      tip: Array,
      source: Array
    },
    asynMajor: {
      types: Array,
      spotSize: Number,
      tip: Array,
      source: Array
    },
    asynMinor: {
      types: Array,
      spotSize: Number,
      tip: Array,
      source: Array
    },
    asynSubset: {
      types: Array,
      spotSize: Number,
      tip: Array,
      source: Array
    },
    asynGround: String,
  },
  mounted() {

    if (this.groundtruth_source === ''){
      this.groundtruth_source = this.asynGround
      this.classification_info= this.asynClassification
      this.annot_type_info= this.asynAnnot
      this.fine_annot_type_info= this.asynFineAnno
      this.celltype_info = this.asynCelltype
      this.celltype_major_info = this.asynMajor
      this.celltype_minor_info = this.asynMinor
      this.celltype_subset_info = this.asynSubset
      if (this.datasetInfo !== null && this.datasetInfo.length !== 0){
        this.datasetID = this.datasetInfo[0].datasetID
        if (this.datasetName.includes(parseInt(this.datasetID))){
          this.picText = 'Immunofluorescent imaging'
          // console.log(this.picText)
        }
      }
      this.$nextTick(function () {
        // echart_list
        // 'domain', 'annotation', 'fine annotation', 'cell type', 'cell type major', 'cell type minor', 'cell type subset'
        if (this.classification_info.source.length !== 0) {
          this.echart_list.push("domain")
        }
        if (this.annot_type_info.source.length !== 0) {
          this.echart_list.push("annotation")
        }
        if (this.fine_annot_type_info.source.length !== 0) {
          this.echart_list.push("fine annotation")
        }
        if (this.celltype_info.source.length !== 0) {
          this.echart_list.push("cell type")
        }
        if (this.celltype_major_info.source.length !== 0) {
          this.echart_list.push("cell type major")
        }
        if (this.celltype_minor_info.source.length !== 0) {
          this.echart_list.push("cell type minor")
        }
        if (this.celltype_subset_info.source.length !== 0) {
          this.echart_list.push("cell type subset")
        }
        this.echart_select = this.echart_list[0]
        this.initEcharts()
        // this.initClassificationEcharts()
        // this.initAnnoEcharts()
        // this.initFineAnnoEcharts()
        // this.initCelltypeEcharts()
        // this.initMajorEcharts()
        // this.initMinorEcharts()
        // this.initSubsetEcharts()
      })
      // setTimeout(()=>{
      //   // console.log(this.groundtruth_source)
      //   // console.log(this.classification_info)
      //   // console.log(this.annot_type_info)
      //   // console.log(this.fine_annot_type_info)
      //   this.initClassificationEcharts()
      //   this.initAnnoEcharts()
      //   this.initFineAnnoEcharts()
      //   this.initCelltypeEcharts()
      //   this.initMajorEcharts()
      //   this.initMinorEcharts()
      //   this.initSubsetEcharts()
      // },500)
    }
  },
  methods:{
    resetPic(elename) {
      this.rotateX = 0
      this.rotateY = 0
      this.rotateZ = 0
      var box = document.getElementById(elename);
      box.style.transform = 'rotateX(' + 0 + 'deg)';
      box.style.transform = 'rotateY(' + 0 + 'deg)';
      box.style.transform = 'rotateZ(' + 0 + 'deg)';
    },
    rotatePic(elename) {
      this.rotateZ = this.rotateZ + 1
      var box = document.getElementById(elename);
      box.style.transform = 'rotateZ(' + 90 * this.rotateZ + 'deg)';
    },
    horizonPic(elename) {
      this.rotateY = this.rotateY + 1
      var box = document.getElementById(elename);
      box.style.transform = 'rotateY(' + 180 * this.rotateY + 'deg)';
    },
    verticalPic(elename) {
      this.rotateX = this.rotateX + 1
      var box = document.getElementById(elename);
      box.style.transform = 'rotateX(' + 180 * this.rotateX + 'deg)';
    },
    hidePic () {
      document.getElementById('groundtruth_allLable').style.display = "none"
    },
    initEcharts(){
      let _this = this
      let _div = document.getElementById('echart_allLable');
      let myChart = this.$echarts.getInstanceByDom(_div);
      if (myChart == null) {
        myChart = echarts.init(_div);
      }
      let info;
      if (_this.echart_select === 'domain'){
        info = _this.classification_info
      }else if (_this.echart_select === 'annotation'){
        info = _this.annot_type_info
      }else if (_this.echart_select === 'fine annotation'){
        info = _this.fine_annot_type_info
      }else if (_this.echart_select === 'cell type'){
        info = _this.celltype_info
      }else if (_this.echart_select === 'cell type major'){
        info = _this.celltype_major_info
      }else if (_this.echart_select === 'cell type minor'){
        info = _this.celltype_minor_info
      }else if (_this.echart_select === 'cell type subset'){
        info = _this.celltype_subset_info
      }else {
        info = {
          types: [],
            spotSize: 5,
            tip: [],
            source: []
        }
      }
      let option;
      option = {
        title:{
          text: _this.echart_select,
          left: 'center'
        },
        toolbox: {
          feature: {
            dataZoom: {
              show: true,
              title: {
                zoom: 'zoom',
                back: 'back'
              },
            },
            saveAsImage : {
              show: true,
              title: "save",
              pixelRatio: 15  //值越大分辨率越高,下载的图片越清晰
            },
          },
        },
        dataset: {
          source: info.source
        },
        tooltip: {
          show: true,
          position: 'bottom'
        },
        visualMap: {
          type: 'piecewise',
          top: 'middle',
          right: 0,
          dimension: 0,
          seriesIndex: 0,
          categories: info.types,
          inRange: {
            color: ['#37A2DA','#e06343','#37a354','#b55dba','#b5bd48','#8378EA','#96BFFF','#E72178',
              '#354E6C','#EAAC31','#EAD2AE','#127678','#30B5A4','#B4D9D2','#354581','#FFE074',
              '#E03C79','#88C1B8','#FC6746','#F5B307','#008186'
            ]
          },
          // formatter: function (value) {
          //   return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
          // },
        },
        dataZoom: [
          {
            left: 0,
            type: 'slider', // 放大和缩小
            orient: 'vertical',
            width: 15
          },
          {
            type: "slider",
            height: 15,
          }
        ],
        grid: {
          right: 100
        },
        xAxis: {
          type: 'value',
          name: 'x',
          nameGap: 16,
          nameTextStyle: {
            fontSize: 16
          },
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          name: 'y',
          nameLocation: 'end',
          nameGap: 20,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        series: [{
          show: false,
          name: 'Detail',
          type: 'scatter',
          encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
          symbolSize: info.spotSize,
          itemStyle: {
            normal:{
              color: function (p){
                let index = info.types.indexOf(p.value[0])
                // if(p.data[0] === 'NA'){console.log(p.data)}
                return _this.COLOR_ALL[index]
              }
            }
          }
        }]
      }
      option && myChart.setOption(option);
    },
    initClassificationEcharts(){
      let _this = this
      let _div = document.getElementById('classification_allLable');
      let myChart = this.$echarts.getInstanceByDom(_div);
      if (myChart == null) {
        myChart = echarts.init(_div);
      }
      let option;
      option = {
        title:{
          text: 'spatial domain',
          left: 'center'
        },
        toolbox: {
          feature: {
            dataZoom: {
              show: true,
              title: {
                zoom: 'zoom',
                back: 'back'
              },
            },
            saveAsImage : {
              show: true,
              title: "save",
              pixelRatio: 15  //值越大分辨率越高,下载的图片越清晰
            },
          },
        },
        dataset: {
          source: _this.classification_info.source
        },
        tooltip: {
          show: true,
          position: 'bottom'
        },
        visualMap: {
          type: 'piecewise',
          top: 'middle',
          right: 0,
          dimension: 0,
          seriesIndex: 0,
          // pieces: _this.classification_info.tip，
          categories: _this.classification_info.types,
          inRange: {
            color: ['#37A2DA','#e06343','#37a354','#b55dba','#b5bd48','#8378EA','#96BFFF','#E72178',
              '#354E6C','#EAAC31','#EAD2AE','#127678','#30B5A4','#B4D9D2','#354581','#FFE074',
              '#E03C79','#88C1B8','#FC6746','#F5B307','#008186'
            ]
          },
          // formatter: function (value) {
          //   return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
          // },
        },
        dataZoom: [
          {
            left: 0,
            type: 'slider', // 放大和缩小
            orient: 'vertical',
            width: 15
          },
          {
            type: "slider",
            height: 15,
          }
        ],
        grid: {
          right: 100
        },
        xAxis: {
          type: 'value',
          name: 'x',
          nameGap: 16,
          nameTextStyle: {
            fontSize: 16
          },
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          name: 'y',
          nameLocation: 'end',
          nameGap: 20,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        series: [{
          show: false,
          name: 'Detail',
          type: 'scatter',
          encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
          symbolSize: _this.classification_info.spotSize,
          itemStyle: {
            normal:{
              color: function (p){
                let index = _this.classification_info.types.indexOf(p.value[0])
                // if(p.data[0] === 'NA'){console.log(p.data)}
                return _this.COLOR_ALL[index]
              }
            }
          }
        }]
      }
      option && myChart.setOption(option);
    },
    initAnnoEcharts(){
      let _this = this
      let _div = document.getElementById('anno_allLable');
      let myChart = this.$echarts.getInstanceByDom(_div);
      if (myChart == null) {
        myChart = echarts.init(_div);
      }
      let option;
      option = {
        title:{
          text: 'annotation type',
          left: 'center'
        },
        toolbox: {
          feature: {
            dataZoom: {
              show: true,
              title: {
                zoom: 'zoom',
                back: 'back'
              },
            },
            saveAsImage : {
              show: true,
              title: "save",
              pixelRatio: 15  //值越大分辨率越高,下载的图片越清晰
            },
          },
        },
        dataset: {
          source: _this.annot_type_info.source
        },
        tooltip: {
          show: true,
          position: 'bottom'
        },
        // visualMap: _this.echart_info_overview.classification_info.tip,
        visualMap: {
          type: 'piecewise',
          top: 'middle',
          right: 0,
          dimension: 0,
          seriesIndex: 0,
          // pieces: _this.annot_type_info.tip,
          categories: _this.annot_type_info.types,
          inRange: {
            color: ['#37A2DA','#e06343','#37a354','#b55dba','#b5bd48','#8378EA','#96BFFF','#E72178',
              '#354E6C','#EAAC31','#EAD2AE','#127678','#30B5A4','#B4D9D2','#354581','#FFE074',
              '#E03C79','#88C1B8','#FC6746','#F5B307','#008186'
            ]
          },
          // formatter: function (value) {
          //   return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
          // },
          // categories: ['Stroma', 'Invasive cancer + stroma + lymphocytes','Invasive cancer + stroma','NA','Artefact'],
        },
        dataZoom: [
          {
            left: 0,
            type: 'slider', // 放大和缩小
            orient: 'vertical',
            width: 15
          },
          {
            type: "slider",
            height: 15,
          }
        ],
        grid: {
          right: 100
        },
        xAxis: {
          type: 'value',
          name: 'x',
          nameGap: 16,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          name: 'y',
          nameLocation: 'end',
          nameGap: 20,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        // series: _this.echart_info_overview.classification_info.series
        series: [{
          show: false,
          name: 'Detail',
          type: 'scatter',
          encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
          symbolSize: _this.annot_type_info.spotSize,
          // symbolSize: 10,
          itemStyle: {
            // color: '#ff0000'
            normal:{
              color: function (p){
                let index = _this.annot_type_info.types.indexOf(p.value[0])
                // if(p.data[0] === 'NA'){console.log(p.data)}
                return _this.COLOR_ALL[index]
              }
            }
          }
        }]
      }
      option && myChart.setOption(option);
    },
    initFineAnnoEcharts(){
      let _this = this
      let _div = document.getElementById('fine_anno_allLable');
      let myChart = this.$echarts.getInstanceByDom(_div);
      if (myChart == null) {
        myChart = echarts.init(_div);
      }
      let option;
      option = {
        title:{
          text: 'fine annotation type',
          left: 'center'
        },
        toolbox: {
          feature: {
            dataZoom: {
              show: true,
              title: {
                zoom: 'zoom',
                back: 'back'
              },
            },
            saveAsImage : {
              show: true,
              title: "save",
              pixelRatio: 15  //值越大分辨率越高,下载的图片越清晰
            },
          },
        },
        dataset: {
          source: _this.fine_annot_type_info.source
        },
        tooltip: {
          show: true,
          position: 'bottom'
        },
        // visualMap: _this.echart_info_overview.classification_info.tip,
        visualMap: {
          type: 'piecewise',
          top: 'middle',
          right: 0,
          dimension: 0,
          seriesIndex: 0,
          // pieces: _this.fine_annot_type_info.tip,
          categories: _this.fine_annot_type_info.types,
          inRange: {
            color: ['#37A2DA','#e06343','#37a354','#b55dba','#b5bd48','#8378EA','#96BFFF','#E72178',
              '#354E6C','#EAAC31','#EAD2AE','#127678','#30B5A4','#B4D9D2','#354581','#FFE074',
              '#E03C79','#88C1B8','#FC6746','#F5B307','#008186'
            ]
          },
          // formatter: function (value) {
          //   return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
          // },
          // categories: ['Stroma', 'Invasive cancer + stroma + lymphocytes','Invasive cancer + stroma','NA','Artefact'],
        },
        dataZoom: [
          {
            left: 0,
            type: 'slider', // 放大和缩小
            orient: 'vertical',
            width: 15
          },
          {
            type: "slider",
            height: 15,
          }
        ],
        grid: {
          right: 100
        },
        xAxis: {
          type: 'value',
          name: 'x',
          nameGap: 16,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          name: 'y',
          nameLocation: 'end',
          nameGap: 20,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        // series: _this.echart_info_overview.classification_info.series
        series: [{
          show: false,
          name: 'Detail',
          type: 'scatter',
          encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
          symbolSize: _this.fine_annot_type_info.spotSize,
          // symbolSize: 10,
          itemStyle: {
            // color: '#ff0000'
            normal:{
              color: function (p){
                let index = _this.fine_annot_type_info.types.indexOf(p.value[0])
                // if(p.data[0] === 'NA'){console.log(p.data)}
                return _this.COLOR_ALL[index]
              }
            }
          }
        }]
      }
      option && myChart.setOption(option);
    },
    initCelltypeEcharts(){
      let _this = this
      let _div = document.getElementById('celltype_allLable');
      let myChart = this.$echarts.getInstanceByDom(_div);
      if (myChart == null) {
        myChart = echarts.init(_div);
      }
      let option;
      option = {
        title:{
          text: 'celltype',
          left: 'center'
        },
        toolbox: {
          feature: {
            dataZoom: {
              show: true,
              title: {
                zoom: 'zoom',
                back: 'back'
              },
            },
            saveAsImage: {
              show: true,
              title: "save",
              pixelRatio: 15  //值越大分辨率越高,下载的图片越清晰
            },
          },
        },
        dataset: {
          source: _this.celltype_info.source
        },
        tooltip: {
          show: true,
          position: 'bottom'
        },
        // visualMap: _this.echart_info_marker.classification_info.tip,
        visualMap: {
          type: 'piecewise',
          top: 'middle',
          right: 0,
          dimension: 0,
          seriesIndex: 0,
          // pieces: _this.celltype_info.tip,
          categories: _this.celltype_info.types,
          inRange: {
            color: ['#37A2DA','#e06343','#37a354','#b55dba','#b5bd48','#8378EA','#96BFFF','#E72178',
              '#354E6C','#EAAC31','#EAD2AE','#127678','#30B5A4','#B4D9D2','#354581','#FFE074',
              '#E03C79','#88C1B8','#FC6746','#F5B307','#008186'
            ]
          },
          // formatter: function (value) {
          //   return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
          // },
          // categories: ['Stroma', 'Invasive cancer + stroma + lymphocytes','Invasive cancer + stroma','NA','Artefact'],
        },
        dataZoom: [
          {
            left: 0,
            type: 'slider', // 放大和缩小
            orient: 'vertical',
            width: 15
          },
          {
            type: "slider",
            height: 15,
          }
        ],
        grid: {
          right: 100
        },
        xAxis: {
          type: 'value',
          name: 'x',
          nameGap: 16,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          name: 'y',
          nameLocation: 'end',
          nameGap: 20,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        // series: _this.echart_info_marker.classification_info.series
        series: [{
          show: false,
          name: 'Detail',
          type: 'scatter',
          encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
          symbolSize: _this.celltype_info.spotSize,
          // symbolSize: 10,
          itemStyle: {
            // color: '#ff0000'
            normal:{
              color: function (p){
                let index = _this.celltype_info.types.indexOf(p.value[0])
                return _this.COLOR_ALL[index]
                // return '#000000'
              }
            }
          }
        }]
      }
      option && myChart.setOption(option);
    },
    initMajorEcharts(){
      let _this = this
      let _div = document.getElementById('celltype_major_allLable')
      let myChart = this.$echarts.getInstanceByDom(_div);
      if (myChart == null) {
        myChart = echarts.init(_div);
      }
      let option;
      option = {
        title:{
          text: 'celltype_major',
          left: 'center'
        },
        toolbox: {
          feature: {
            dataZoom: {
              show: true,
              title: {
                zoom: 'zoom',
                back: 'back'
              },
            },
            saveAsImage: {
              show: true,
              title: "save",
              pixelRatio: 15  //值越大分辨率越高,下载的图片越清晰
            },
          },
        },
        dataset: {
          source: _this.celltype_major_info.source
        },
        tooltip: {
          show: true,
          position: 'bottom'
        },
        // visualMap: _this.echart_info_marker.classification_info.tip,
        visualMap: {
          type: 'piecewise',
          top: 'middle',
          right: 0,
          dimension: 0,
          seriesIndex: 0,
          // pieces: _this.celltype_major_info.tip,
          categories: _this.celltype_major_info.types,
          inRange: {
            color: ['#37A2DA','#e06343','#37a354','#b55dba','#b5bd48','#8378EA','#96BFFF','#E72178',
              '#354E6C','#EAAC31','#EAD2AE','#127678','#30B5A4','#B4D9D2','#354581','#FFE074',
              '#E03C79','#88C1B8','#FC6746','#F5B307','#008186'
            ]
          },
          // formatter: function (value) {
          //   return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
          // },
          // categories: ['Stroma', 'Invasive cancer + stroma + lymphocytes','Invasive cancer + stroma','NA','Artefact'],
        },
        dataZoom: [
          {
            left: 0,
            type: 'slider', // 放大和缩小
            orient: 'vertical',
            width: 15
          },
          {
            type: "slider",
            height: 15,
          }
        ],
        grid: {
          right: 100
        },
        xAxis: {
          type: 'value',
          name: 'x',
          nameGap: 16,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          name: 'y',
          nameLocation: 'end',
          nameGap: 20,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        // series: _this.echart_info_marker.classification_info.series
        series: [{
          show: false,
          name: 'Detail',
          type: 'scatter',
          encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
          symbolSize: _this.celltype_major_info.spotSize,
          // symbolSize: 10,
          itemStyle: {
            // color: '#ff0000'
            normal:{
              color: function (p){
                let index = _this.celltype_major_info.types.indexOf(p.value[0])
                return _this.COLOR_ALL[index]
                // return '#000000'
              }
            }
          }
        }]
      }
      option && myChart.setOption(option);
    },
    initMinorEcharts(){
      let _this = this
      let _div = document.getElementById('celltype_minor_allLable')
      let myChart = this.$echarts.getInstanceByDom(_div);
      if (myChart == null) {
        myChart = echarts.init(_div);
      }
      let option;
      option = {
        title:{
          text: 'celltype_minor',
          left: 'center'
        },
        toolbox: {
          feature: {
            dataZoom: {
              show: true,
              title: {
                zoom: 'zoom',
                back: 'back'
              },
            },
            saveAsImage: {
              show: true,
              title: "save",
              pixelRatio: 15  //值越大分辨率越高,下载的图片越清晰
            },
          },
        },
        dataset: {
          source: _this.celltype_minor_info.source
        },
        tooltip: {
          show: true,
          position: 'bottom'
        },
        // visualMap: _this.echart_info_marker.classification_info.tip,
        visualMap: {
          type: 'piecewise',
          top: 'middle',
          right: 0,
          dimension: 0,
          seriesIndex: 0,
          // pieces: _this.celltype_minor_info.tip,
          categories: _this.celltype_minor_info.types,
          inRange: {
            color: ['#37A2DA','#e06343','#37a354','#b55dba','#b5bd48','#8378EA','#96BFFF','#E72178',
              '#354E6C','#EAAC31','#EAD2AE','#127678','#30B5A4','#B4D9D2','#354581','#FFE074',
              '#E03C79','#88C1B8','#FC6746','#F5B307','#008186'
            ]
          },
          // formatter: function (value) {
          //   return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
          // },
          // categories: ['Stroma', 'Invasive cancer + stroma + lymphocytes','Invasive cancer + stroma','NA','Artefact'],
        },
        dataZoom: [
          {
            left: 0,
            type: 'slider', // 放大和缩小
            orient: 'vertical',
            width: 15
          },
          {
            type: "slider",
            height: 15,
          }
        ],
        grid: {
          right: 100
        },
        xAxis: {
          type: 'value',
          name: 'x',
          nameGap: 16,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          name: 'y',
          nameLocation: 'end',
          nameGap: 20,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        // series: _this.echart_info_marker.classification_info.series
        series: [{
          show: false,
          name: 'Detail',
          type: 'scatter',
          encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
          symbolSize: _this.celltype_minor_info.spotSize,
          // symbolSize: 10,
          itemStyle: {
            // color: '#ff0000'
            normal:{
              color: function (p){
                let index = _this.celltype_minor_info.types.indexOf(p.value[0])
                return _this.COLOR_ALL[index]
                // return '#000000'
              }
            }
          }
        }]
      }
      option && myChart.setOption(option);
    },
    initSubsetEcharts(){
      let _this = this
      let _div = document.getElementById('celltype_subset_allLable')
      let myChart = this.$echarts.getInstanceByDom(_div);
      if (myChart == null) {
        myChart = echarts.init(_div);
      }
      let option;
      option = {
        title:{
          text: 'celltype_subset',
          left: 'center'
        },
        toolbox: {
          feature: {
            dataZoom: {
              show: true,
              title: {
                zoom: 'zoom',
                back: 'back'
              },
            },
            saveAsImage: {
              show: true,
              title: "save",
              pixelRatio: 15  //值越大分辨率越高,下载的图片越清晰
            },
          },
        },
        dataset: {
          source: _this.celltype_subset_info.source
        },
        tooltip: {
          show: true,
          position: 'bottom'
        },
        // visualMap: _this.echart_info_marker.classification_info.tip,
        visualMap: {
          type: 'piecewise',
          top: 'middle',
          right: 0,
          dimension: 0,
          seriesIndex: 0,
          // pieces: _this.celltype_subset_info.tip,
          categories: _this.celltype_subset_info.types,
          inRange: {
            color: ['#37A2DA','#e06343','#37a354','#b55dba','#b5bd48','#8378EA','#96BFFF','#E72178',
              '#354E6C','#EAAC31','#EAD2AE','#127678','#30B5A4','#B4D9D2','#354581','#FFE074',
              '#E03C79','#88C1B8','#FC6746','#F5B307','#008186'
            ]
          },
          // formatter: function (value) {
          //   return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
          // },
          // categories: ['Stroma', 'Invasive cancer + stroma + lymphocytes','Invasive cancer + stroma','NA','Artefact'],
        },
        dataZoom: [
          {
            left: 0,
            type: 'slider', // 放大和缩小
            orient: 'vertical',
            width: 15
          },
          {
            type: "slider",
            height: 15,
          }
        ],
        grid: {
          right: 100
        },
        xAxis: {
          type: 'value',
          name: 'x',
          nameGap: 16,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          name: 'y',
          nameLocation: 'end',
          nameGap: 20,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        // series: _this.echart_info_marker.classification_info.series
        series: [{
          name: 'Detail',
          type: 'scatter',
          encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
          symbolSize: _this.celltype_subset_info.spotSize,
          // symbolSize: 10,
          itemStyle: {
            // color: '#ff0000'
            normal:{
              color: function (p){
                let index = _this.celltype_subset_info.types.indexOf(p.value[0])
                return _this.COLOR_ALL[index]
              }
            }
          }
        }]
      }
      option && myChart.setOption(option);
    },
    changeEcharts(){},
  },
}
</script>

<style scoped>
#echarts_pics{
  /*height: 450px;*/
  width: 400px;
  padding: 10px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
}

.flex_column_all_label{
  width: 900px;
  height: 450px;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  z-index: 99;
}
.flex_row_all_label{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
}
</style>
